<app-page-loader *ngIf="appLoading" [text]="appLoadingText"></app-page-loader>
<app-toast [toasts]="notifications$ | async" [autoCloseDelay]="5"></app-toast>
<router-outlet></router-outlet>
